import { isMobile } from 'react-device-detect'
import { type NextPage } from 'next'
import { useRouter } from 'next/router'
import { webviewRuntime } from 'modules/shared/page-enhancers/src/utils/webview-runtime'

import { Loader } from '~/domains/platform/design-system/loader/loader'
import BlackBird from '~/domains/platform/lib/blackbird'
import { CleanPageContainer } from '~/ui/containers/clean-page-container'

const BYPASS_ROUTES = ['/open-finance/payment', '/open-finance/my-payments']

export function withRedirectToMobileOnSmallScreen(Page: NextPage<any>) {
  function WrappedPage(props: any) {
    const { pathname } = useRouter()
    const isWebView = webviewRuntime.isWebView()
    if (isMobile && !BYPASS_ROUTES.includes(pathname) && !isWebView) {
      BlackBird.travelTo('/confira-o-app')

      return (
        <CleanPageContainer>
          <Loader />
        </CleanPageContainer>
      )
    }

    return <Page {...props} />
  }

  WrappedPage.displayName = `withRedirectToMobileOnSmallScreen(${Page.displayName})`

  return WrappedPage
}
